import { ArrowUpRight } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useTranslations } from "next-intl"
import Link from "next/link"
import { getAuthUrl } from "@/lib/auth-urls"
import { useLanguage } from "@/lib/LanguageContext"

const CTA = () => {
    // Changed translation scope from 'marketing.ctaFooter' to 'ctaFooter' as it is a top-level key
    const t = useTranslations('ctaFooter')
    const { language } = useLanguage()

    return (

        <section className="px-4 py-12 md:py-20 bg-background">
            <div className="relative mx-auto max-w-screen-lg overflow-hidden border px-4 py-10 sm:px-10 sm:py-14 text-center shadow-lg rounded-xl bg-card border-border">
                <h2 className="text-balance font-semibold text-4xl tracking-tight md:leading-tight lg:text-5xl text-foreground">
                    {t('title')}
                </h2>
                <p className="mt-3 text-2xl text-muted-foreground">
                    {t('description')}
                </p>
                <Button className="mt-12 z-10 relative rounded-md from-primary to-primary/85 text-primary-foreground dark:inset-shadow-2xs dark:inset-shadow-white/10 bg-linear-to-t border border-b-2 border-zinc-950/40 shadow-md shadow-zinc-950/20 ring-1 ring-inset ring-white/25 transition-[filter] duration-200 hover:brightness-110 active:brightness-90 dark:border-x-0 dark:border-t-0 dark:border-zinc-950/50 dark:ring-white/5" size="lg" asChild>
                    <Link href={getAuthUrl(language, '/signup')}>
                        {/* RTL support for the arrow icon */}
                        {t('button')} <ArrowUpRight className="ml-2 w-4 h-4 rtl:mr-2 rtl:ml-0 rtl:rotate-180" />
                    </Link>
                </Button>

                <CTABackground />
            </div>
        </section>
    )
}

const CTABackground = () => {
    return (
        <svg
            className="absolute inset-0 isolate z-0 h-full sm:h-auto pointer-events-none opacity-40 dark:opacity-20"
            version="1.1"
            viewBox="0 0 1422 800"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                className="stroke-foreground/10"
                fill="none"
                strokeLinecap="butt"
                strokeWidth="2.5"
            >
                <line x1="54" x2="0" y1="0" y2="54" />
                <line x1="108" x2="54" y1="0" y2="54" />
                <line x1="162" x2="108" y1="0" y2="54" />
                <line x1="162" x2="216" y1="0" y2="54" />
                <line x1="216" x2="270" y1="0" y2="54" />
                <line x1="270" x2="324" y1="0" y2="54" />
                <line x1="378" x2="324" y1="0" y2="54" />
                <line x1="378" x2="432" y1="0" y2="54" />
                <line x1="432" x2="486" y1="0" y2="54" />
                <line x1="540" x2="486" y1="0" y2="54" />
                <line x1="594" x2="540" y1="0" y2="54" />
                <line x1="594" x2="648" y1="0" y2="54" />
                <line x1="702" x2="648" y1="0" y2="54" />
                <line x1="756" x2="702" y1="0" y2="54" />
                <line x1="756" x2="810" y1="0" y2="54" />
                <line x1="864" x2="810" y1="0" y2="54" />
                <line x1="864" x2="918" y1="0" y2="54" />
                <line x1="972" x2="918" y1="0" y2="54" />
                <line x1="1026" x2="972" y1="0" y2="54" />
                <line x1="1080" x2="1026" y1="0" y2="54" />
                <line x1="1080" x2="1134" y1="0" y2="54" />
                <line x1="1134" x2="1188" y1="0" y2="54" />
                <line x1="1242" x2="1188" y1="0" y2="54" />
                <line x1="1296" x2="1242" y1="0" y2="54" />
                <line x1="1296" x2="1350" y1="0" y2="54" />
                <line x1="1350" x2="1404" y1="0" y2="54" />
                <line x1="1458" x2="1404" y1="0" y2="54" />
                <line x1="0" x2="54" y1="54" y2="108" />
                <line x1="54" x2="108" y1="54" y2="108" />
                <line x1="108" x2="162" y1="54" y2="108" />
                <line x1="162" x2="216" y1="54" y2="108" />
                <line x1="270" x2="216" y1="54" y2="108" />
                <line x1="270" x2="324" y1="54" y2="108" />
                <line x1="324" x2="378" y1="54" y2="108" />
                <line x1="378" x2="432" y1="54" y2="108" />
                <line x1="486" x2="432" y1="54" y2="108" />
                <line x1="540" x2="486" y1="54" y2="108" />
                <line x1="540" x2="594" y1="54" y2="108" />
                <line x1="648" x2="594" y1="54" y2="108" />
                <line x1="648" x2="702" y1="54" y2="108" />
                <line x1="756" x2="702" y1="54" y2="108" />
                <line x1="810" x2="756" y1="54" y2="108" />
                <line x1="810" x2="864" y1="54" y2="108" />
                <line x1="918" x2="864" y1="54" y2="108" />
                <line x1="972" x2="918" y1="54" y2="108" />
                <line x1="972" x2="1026" y1="54" y2="108" />
                <line x1="1026" x2="1080" y1="54" y2="108" />
                <line x1="1080" x2="1134" y1="54" y2="108" />
                <line x1="1188" x2="1134" y1="54" y2="108" />
                <line x1="1188" x2="1242" y1="54" y2="108" />
                <line x1="1296" x2="1242" y1="54" y2="108" />
                <line x1="1296" x2="1350" y1="54" y2="108" />
                <line x1="1404" x2="1350" y1="54" y2="108" />
                <line x1="1404" x2="1458" y1="54" y2="108" />
                <line x1="0" x2="54" y1="108" y2="162" />
                <line x1="54" x2="108" y1="108" y2="162" />
                <line x1="108" x2="162" y1="108" y2="162" />
                <line x1="162" x2="216" y1="108" y2="162" />
                <line x1="216" x2="270" y1="108" y2="162" />
                <line x1="324" x2="270" y1="108" y2="162" />
                <line x1="324" x2="378" y1="108" y2="162" />
                <line x1="378" x2="432" y1="108" y2="162" />
                <line x1="432" x2="486" y1="108" y2="162" />
                <line x1="540" x2="486" y1="108" y2="162" />
                <line x1="594" x2="540" y1="108" y2="162" />
                <line x1="648" x2="594" y1="108" y2="162" />
                <line x1="648" x2="702" y1="108" y2="162" />
                <line x1="702" x2="756" y1="108" y2="162" />
                <line x1="810" x2="756" y1="108" y2="162" />
                <line x1="810" x2="864" y1="108" y2="162" />
                <line x1="918" x2="864" y1="108" y2="162" />
                <line x1="972" x2="918" y1="108" y2="162" />
                <line x1="972" x2="1026" y1="108" y2="162" />
                <line x1="1026" x2="1080" y1="108" y2="162" />
                <line x1="1134" x2="1080" y1="108" y2="162" />
                <line x1="1188" x2="1134" y1="108" y2="162" />
                <line x1="1242" x2="1188" y1="108" y2="162" />
                <line x1="1242" x2="1296" y1="108" y2="162" />
                <line x1="1296" x2="1350" y1="108" y2="162" />
                <line x1="1350" x2="1404" y1="108" y2="162" />
                <line x1="1404" x2="1458" y1="108" y2="162" />
                <line x1="0" x2="54" y1="162" y2="216" />
                <line x1="54" x2="108" y1="162" y2="216" />
                <line x1="108" x2="162" y1="162" y2="216" />
                <line x1="216" x2="162" y1="162" y2="216" />
                <line x1="270" x2="216" y1="162" y2="216" />
                <line x1="270" x2="324" y1="162" y2="216" />
                <line x1="378" x2="324" y1="162" y2="216" />
                <line x1="378" x2="432" y1="162" y2="216" />
                <line x1="432" x2="486" y1="162" y2="216" />
                <line x1="540" x2="486" y1="162" y2="216" />
                <line x1="594" x2="540" y1="162" y2="216" />
                <line x1="648" x2="594" y1="162" y2="216" />
                <line x1="702" x2="648" y1="162" y2="216" />
                <line x1="702" x2="756" y1="162" y2="216" />
                <line x1="810" x2="756" y1="162" y2="216" />
                <line x1="864" x2="810" y1="162" y2="216" />
                <line x1="864" x2="918" y1="162" y2="216" />
                <line x1="972" x2="918" y1="162" y2="216" />
                <line x1="1026" x2="972" y1="162" y2="216" />
                <line x1="1026" x2="1080" y1="162" y2="216" />
                <line x1="1134" x2="1080" y1="162" y2="216" />
                <line x1="1134" x2="1188" y1="162" y2="216" />
                <line x1="1242" x2="1188" y1="162" y2="216" />
                <line x1="1242" x2="1296" y1="162" y2="216" />
                <line x1="1296" x2="1350" y1="162" y2="216" />
                <line x1="1350" x2="1404" y1="162" y2="216" />
                <line x1="1404" x2="1458" y1="162" y2="216" />
                <line x1="54" x2="0" y1="216" y2="270" />
                <line x1="54" x2="108" y1="216" y2="270" />
                <line x1="162" x2="108" y1="216" y2="270" />
                <line x1="216" x2="162" y1="216" y2="270" />
                <line x1="270" x2="216" y1="216" y2="270" />
                <line x1="324" x2="270" y1="216" y2="270" />
                <line x1="324" x2="378" y1="216" y2="270" />
                <line x1="432" x2="378" y1="216" y2="270" />
                <line x1="486" x2="432" y1="216" y2="270" />
                <line x1="486" x2="540" y1="216" y2="270" />
                <line x1="540" x2="594" y1="216" y2="270" />
                <line x1="648" x2="594" y1="216" y2="270" />
                <line x1="702" x2="648" y1="216" y2="270" />
                <line x1="702" x2="756" y1="216" y2="270" />
                <line x1="756" x2="810" y1="216" y2="270" />
                <line x1="864" x2="810" y1="216" y2="270" />
                <line x1="918" x2="864" y1="216" y2="270" />
                <line x1="972" x2="918" y1="216" y2="270" />
                <line x1="1026" x2="972" y1="216" y2="270" />
                <line x1="1026" x2="1080" y1="216" y2="270" />
                <line x1="1134" x2="1080" y1="216" y2="270" />
                <line x1="1134" x2="1188" y1="216" y2="270" />
                <line x1="1188" x2="1242" y1="216" y2="270" />
                <line x1="1296" x2="1242" y1="216" y2="270" />
                <line x1="1350" x2="1296" y1="216" y2="270" />
                <line x1="1350" x2="1404" y1="216" y2="270" />
                <line x1="1458" x2="1404" y1="216" y2="270" />
                <line x1="54" x2="0" y1="270" y2="324" />
                <line x1="54" x2="108" y1="270" y2="324" />
                <line x1="162" x2="108" y1="270" y2="324" />
                <line x1="162" x2="216" y1="270" y2="324" />
                <line x1="270" x2="216" y1="270" y2="324" />
                <line x1="324" x2="270" y1="270" y2="324" />
                <line x1="324" x2="378" y1="270" y2="324" />
                <line x1="432" x2="378" y1="270" y2="324" />
                <line x1="432" x2="486" y1="270" y2="324" />
                <line x1="540" x2="486" y1="270" y2="324" />
                <line x1="540" x2="594" y1="270" y2="324" />
                <line x1="648" x2="594" y1="270" y2="324" />
                <line x1="702" x2="648" y1="270" y2="324" />
                <line x1="756" x2="702" y1="270" y2="324" />
                <line x1="810" x2="756" y1="270" y2="324" />
                <line x1="810" x2="864" y1="270" y2="324" />
                <line x1="864" x2="918" y1="270" y2="324" />
                <line x1="972" x2="918" y1="270" y2="324" />
                <line x1="1026" x2="972" y1="270" y2="324" />
                <line x1="1026" x2="1080" y1="270" y2="324" />
                <line x1="1080" x2="1134" y1="270" y2="324" />
                <line x1="1188" x2="1134" y1="270" y2="324" />
                <line x1="1242" x2="1188" y1="270" y2="324" />
                <line x1="1296" x2="1242" y1="270" y2="324" />
                <line x1="1350" x2="1296" y1="270" y2="324" />
                <line x1="1350" x2="1404" y1="270" y2="324" />
                <line x1="1458" x2="1404" y1="270" y2="324" />
                <line x1="54" x2="0" y1="324" y2="378" />
                <line x1="108" x2="54" y1="324" y2="378" />
                <line x1="162" x2="108" y1="324" y2="378" />
                <line x1="216" x2="162" y1="324" y2="378" />
                <line x1="216" x2="270" y1="324" y2="378" />
                <line x1="270" x2="324" y1="324" y2="378" />
                <line x1="324" x2="378" y1="324" y2="378" />
                <line x1="432" x2="378" y1="324" y2="378" />
                <line x1="486" x2="432" y1="324" y2="378" />
                <line x1="540" x2="486" y1="324" y2="378" />
                <line x1="540" x2="594" y1="324" y2="378" />
                <line x1="648" x2="594" y1="324" y2="378" />
                <line x1="648" x2="702" y1="324" y2="378" />
                <line x1="702" x2="756" y1="324" y2="378" />
                <line x1="810" x2="756" y1="324" y2="378" />
                <line x1="810" x2="864" y1="324" y2="378" />
                <line x1="864" x2="918" y1="324" y2="378" />
                <line x1="972" x2="918" y1="324" y2="378" />
                <line x1="1026" x2="972" y1="324" y2="378" />
                <line x1="1080" x2="1026" y1="324" y2="378" />
                <line x1="1134" x2="1080" y1="324" y2="378" />
                <line x1="1134" x2="1188" y1="324" y2="378" />
                <line x1="1242" x2="1188" y1="324" y2="378" />
                <line x1="1242" x2="1296" y1="324" y2="378" />
                <line x1="1350" x2="1296" y1="324" y2="378" />
                <line x1="1404" x2="1350" y1="324" y2="378" />
                <line x1="1404" x2="1458" y1="324" y2="378" />
                <line x1="0" x2="54" y1="378" y2="432" />
                <line x1="54" x2="108" y1="378" y2="432" />
                <line x1="108" x2="162" y1="378" y2="432" />
                <line x1="216" x2="162" y1="378" y2="432" />
                <line x1="216" x2="270" y1="378" y2="432" />
                <line x1="270" x2="324" y1="378" y2="432" />
                <line x1="378" x2="324" y1="378" y2="432" />
                <line x1="378" x2="432" y1="378" y2="432" />
                <line x1="432" x2="486" y1="378" y2="432" />
                <line x1="486" x2="540" y1="378" y2="432" />
                <line x1="594" x2="540" y1="378" y2="432" />
                <line x1="594" x2="648" y1="378" y2="432" />
                <line x1="648" x2="702" y1="378" y2="432" />
                <line x1="756" x2="702" y1="378" y2="432" />
                <line x1="756" x2="810" y1="378" y2="432" />
                <line x1="810" x2="864" y1="378" y2="432" />
                <line x1="918" x2="864" y1="378" y2="432" />
                <line x1="918" x2="972" y1="378" y2="432" />
                <line x1="1026" x2="972" y1="378" y2="432" />
                <line x1="1080" x2="1026" y1="378" y2="432" />
                <line x1="1080" x2="1134" y1="378" y2="432" />
                <line x1="1134" x2="1188" y1="378" y2="432" />
                <line x1="1188" x2="1242" y1="378" y2="432" />
                <line x1="1296" x2="1242" y1="378" y2="432" />
                <line x1="1350" x2="1296" y1="378" y2="432" />
                <line x1="1404" x2="1350" y1="378" y2="432" />
                <line x1="1404" x2="1458" y1="378" y2="432" />
                <line x1="54" x2="0" y1="432" y2="486" />
                <line x1="108" x2="54" y1="432" y2="486" />
                <line x1="108" x2="162" y1="432" y2="486" />
                <line x1="216" x2="162" y1="432" y2="486" />
                <line x1="216" x2="270" y1="432" y2="486" />
                <line x1="270" x2="324" y1="432" y2="486" />
                <line x1="378" x2="324" y1="432" y2="486" />
                <line x1="432" x2="378" y1="432" y2="486" />
                <line x1="486" x2="432" y1="432" y2="486" />
                <line x1="486" x2="540" y1="432" y2="486" />
                <line x1="540" x2="594" y1="432" y2="486" />
                <line x1="648" x2="594" y1="432" y2="486" />
                <line x1="648" x2="702" y1="432" y2="486" />
                <line x1="702" x2="756" y1="432" y2="486" />
                <line x1="756" x2="810" y1="432" y2="486" />
                <line x1="810" x2="864" y1="432" y2="486" />
                <line x1="918" x2="864" y1="432" y2="486" />
                <line x1="918" x2="972" y1="432" y2="486" />
                <line x1="972" x2="1026" y1="432" y2="486" />
                <line x1="1080" x2="1026" y1="432" y2="486" />
                <line x1="1080" x2="1134" y1="432" y2="486" />
                <line x1="1188" x2="1134" y1="432" y2="486" />
                <line x1="1188" x2="1242" y1="432" y2="486" />
                <line x1="1242" x2="1296" y1="432" y2="486" />
                <line x1="1296" x2="1350" y1="432" y2="486" />
                <line x1="1404" x2="1350" y1="432" y2="486" />
                <line x1="1458" x2="1404" y1="432" y2="486" />
                <line x1="0" x2="54" y1="486" y2="540" />
                <line x1="108" x2="54" y1="486" y2="540" />
                <line x1="108" x2="162" y1="486" y2="540" />
                <line x1="216" x2="162" y1="486" y2="540" />
                <line x1="270" x2="216" y1="486" y2="540" />
                <line x1="324" x2="270" y1="486" y2="540" />
                <line x1="378" x2="324" y1="486" y2="540" />
                <line x1="378" x2="432" y1="486" y2="540" />
                <line x1="486" x2="432" y1="486" y2="540" />
                <line x1="540" x2="486" y1="486" y2="540" />
                <line x1="540" x2="594" y1="486" y2="540" />
                <line x1="648" x2="594" y1="486" y2="540" />
                <line x1="648" x2="702" y1="486" y2="540" />
                <line x1="756" x2="702" y1="486" y2="540" />
                <line x1="756" x2="810" y1="486" y2="540" />
                <line x1="864" x2="810" y1="486" y2="540" />
                <line x1="864" x2="918" y1="486" y2="540" />
                <line x1="918" x2="972" y1="486" y2="540" />
                <line x1="1026" x2="972" y1="486" y2="540" />
                <line x1="1080" x2="1026" y1="486" y2="540" />
                <line x1="1134" x2="1080" y1="486" y2="540" />
                <line x1="1188" x2="1134" y1="486" y2="540" />
                <line x1="1242" x2="1188" y1="486" y2="540" />
                <line x1="1296" x2="1242" y1="486" y2="540" />
                <line x1="1350" x2="1296" y1="486" y2="540" />
                <line x1="1404" x2="1350" y1="486" y2="540" />
                <line x1="1404" x2="1458" y1="486" y2="540" />
                <line x1="0" x2="54" y1="540" y2="594" />
                <line x1="54" x2="108" y1="540" y2="594" />
                <line x1="162" x2="108" y1="540" y2="594" />
                <line x1="162" x2="216" y1="540" y2="594" />
                <line x1="216" x2="270" y1="540" y2="594" />
                <line x1="270" x2="324" y1="540" y2="594" />
                <line x1="324" x2="378" y1="540" y2="594" />
                <line x1="378" x2="432" y1="540" y2="594" />
                <line x1="486" x2="432" y1="540" y2="594" />
                <line x1="540" x2="486" y1="540" y2="594" />
                <line x1="540" x2="594" y1="540" y2="594" />
                <line x1="648" x2="594" y1="540" y2="594" />
                <line x1="702" x2="648" y1="540" y2="594" />
                <line x1="702" x2="756" y1="540" y2="594" />
                <line x1="810" x2="756" y1="540" y2="594" />
                <line x1="810" x2="864" y1="540" y2="594" />
                <line x1="864" x2="918" y1="540" y2="594" />
                <line x1="972" x2="918" y1="540" y2="594" />
                <line x1="972" x2="1026" y1="540" y2="594" />
                <line x1="1080" x2="1026" y1="540" y2="594" />
                <line x1="1080" x2="1134" y1="540" y2="594" />
                <line x1="1188" x2="1134" y1="540" y2="594" />
                <line x1="1188" x2="1242" y1="540" y2="594" />
                <line x1="1242" x2="1296" y1="540" y2="594" />
                <line x1="1350" x2="1296" y1="540" y2="594" />
                <line x1="1404" x2="1350" y1="540" y2="594" />
                <line x1="1458" x2="1404" y1="540" y2="594" />
                <line x1="0" x2="54" y1="594" y2="648" />
                <line x1="108" x2="54" y1="594" y2="648" />
                <line x1="162" x2="108" y1="594" y2="648" />
                <line x1="216" x2="162" y1="594" y2="648" />
                <line x1="270" x2="216" y1="594" y2="648" />
                <line x1="270" x2="324" y1="594" y2="648" />
                <line x1="378" x2="324" y1="594" y2="648" />
                <line x1="432" x2="378" y1="594" y2="648" />
                <line x1="486" x2="432" y1="594" y2="648" />
                <line x1="486" x2="540" y1="594" y2="648" />
                <line x1="594" x2="540" y1="594" y2="648" />
                <line x1="594" x2="648" y1="594" y2="648" />
                <line x1="702" x2="648" y1="594" y2="648" />
                <line x1="702" x2="756" y1="594" y2="648" />
                <line x1="756" x2="810" y1="594" y2="648" />
                <line x1="864" x2="810" y1="594" y2="648" />
                <line x1="864" x2="918" y1="594" y2="648" />
                <line x1="972" x2="918" y1="594" y2="648" />
                <line x1="1026" x2="972" y1="594" y2="648" />
                <line x1="1026" x2="1080" y1="594" y2="648" />
                <line x1="1080" x2="1134" y1="594" y2="648" />
                <line x1="1134" x2="1188" y1="594" y2="648" />
                <line x1="1188" x2="1242" y1="594" y2="648" />
                <line x1="1242" x2="1296" y1="594" y2="648" />
                <line x1="1350" x2="1296" y1="594" y2="648" />
                <line x1="1350" x2="1404" y1="594" y2="648" />
                <line x1="1404" x2="1458" y1="594" y2="648" />
                <line x1="54" x2="0" y1="648" y2="702" />
                <line x1="108" x2="54" y1="648" y2="702" />
                <line x1="108" x2="162" y1="648" y2="702" />
                <line x1="162" x2="216" y1="648" y2="702" />
                <line x1="216" x2="270" y1="648" y2="702" />
                <line x1="270" x2="324" y1="648" y2="702" />
                <line x1="324" x2="378" y1="648" y2="702" />
                <line x1="378" x2="432" y1="648" y2="702" />
                <line x1="432" x2="486" y1="648" y2="702" />
                <line x1="540" x2="486" y1="648" y2="702" />
                <line x1="540" x2="594" y1="648" y2="702" />
                <line x1="648" x2="594" y1="648" y2="702" />
                <line x1="648" x2="702" y1="648" y2="702" />
                <line x1="702" x2="756" y1="648" y2="702" />
                <line x1="756" x2="810" y1="648" y2="702" />
                <line x1="810" x2="864" y1="648" y2="702" />
                <line x1="918" x2="864" y1="648" y2="702" />
                <line x1="918" x2="972" y1="648" y2="702" />
                <line x1="972" x2="1026" y1="648" y2="702" />
                <line x1="1080" x2="1026" y1="648" y2="702" />
                <line x1="1080" x2="1134" y1="648" y2="702" />
                <line x1="1188" x2="1134" y1="648" y2="702" />
                <line x1="1242" x2="1188" y1="648" y2="702" />
                <line x1="1242" x2="1296" y1="648" y2="702" />
                <line x1="1296" x2="1350" y1="648" y2="702" />
                <line x1="1350" x2="1404" y1="648" y2="702" />
                <line x1="1458" x2="1404" y1="648" y2="702" />
                <line x1="0" x2="54" y1="702" y2="756" />
                <line x1="108" x2="54" y1="702" y2="756" />
                <line x1="162" x2="108" y1="702" y2="756" />
                <line x1="162" x2="216" y1="702" y2="756" />
                <line x1="270" x2="216" y1="702" y2="756" />
                <line x1="270" x2="324" y1="702" y2="756" />
                <line x1="378" x2="324" y1="702" y2="756" />
                <line x1="378" x2="432" y1="702" y2="756" />
                <line x1="432" x2="486" y1="702" y2="756" />
                <line x1="540" x2="486" y1="702" y2="756" />
                <line x1="540" x2="594" y1="702" y2="756" />
                <line x1="594" x2="648" y1="702" y2="756" />
                <line x1="702" x2="648" y1="702" y2="756" />
                <line x1="702" x2="756" y1="702" y2="756" />
                <line x1="756" x2="810" y1="702" y2="756" />
                <line x1="864" x2="810" y1="702" y2="756" />
                <line x1="864" x2="918" y1="702" y2="756" />
                <line x1="918" x2="972" y1="702" y2="756" />
                <line x1="972" x2="1026" y1="702" y2="756" />
                <line x1="1080" x2="1026" y1="702" y2="756" />
                <line x1="1080" x2="1134" y1="702" y2="756" />
                <line x1="1134" x2="1188" y1="702" y2="756" />
                <line x1="1188" x2="1242" y1="702" y2="756" />
                <line x1="1242" x2="1296" y1="702" y2="756" />
                <line x1="1296" x2="1350" y1="702" y2="756" />
                <line x1="1350" x2="1404" y1="702" y2="756" />
                <line x1="1404" x2="1458" y1="702" y2="756" />
                <line x1="54" x2="0" y1="756" y2="810" />
                <line x1="108" x2="54" y1="756" y2="810" />
                <line x1="162" x2="108" y1="756" y2="810" />
                <line x1="216" x2="162" y1="756" y2="810" />
                <line x1="216" x2="270" y1="756" y2="810" />
                <line x1="324" x2="270" y1="756" y2="810" />
                <line x1="324" x2="378" y1="756" y2="810" />
                <line x1="378" x2="432" y1="756" y2="810" />
                <line x1="432" x2="486" y1="756" y2="810" />
                <line x1="486" x2="540" y1="756" y2="810" />
                <line x1="594" x2="540" y1="756" y2="810" />
                <line x1="594" x2="648" y1="756" y2="810" />
                <line x1="648" x2="702" y1="756" y2="810" />
                <line x1="756" x2="702" y1="756" y2="810" />
                <line x1="810" x2="756" y1="756" y2="810" />
                <line x1="864" x2="810" y1="756" y2="810" />
                <line x1="918" x2="864" y1="756" y2="810" />
                <line x1="918" x2="972" y1="756" y2="810" />
                <line x1="1026" x2="972" y1="756" y2="810" />
                <line x1="1080" x2="1026" y1="756" y2="810" />
                <line x1="1080" x2="1134" y1="756" y2="810" />
                <line x1="1134" x2="1188" y1="756" y2="810" />
                <line x1="1188" x2="1242" y1="756" y2="810" />
                <line x1="1242" x2="1296" y1="756" y2="810" />
                <line x1="1296" x2="1350" y1="756" y2="810" />
                <line x1="1350" x2="1404" y1="756" y2="810" />
                <line x1="1458" x2="1404" y1="756" y2="810" />
            </g>
        </svg>
    )
}

export default CTA
